module.exports = __webpack_public_path__ + "static/media/LogoSL.3961311a.png";